import { getSeedMasteryForSubtopic } from '@/lib/recommendation/seed-tier-template'
import type { SubtopicSeedOverride } from './apply-knowledge-map-seed'
import { SEED_BUCKETS, type SeedBucket } from './seed-buckets'
import {
  parseSeedDifficulty,
  parseSeedMastery,
  parseSeedStabilityDays,
} from './seed-override-parse'

export type SubtopicFieldForm = {
  mastery: string
  stabilityDays: string
  difficulty: string
}

export type SeedFormOverrideState = {
  subtopicFields: Record<string, SubtopicFieldForm>
  subtopicIncluded: Record<string, boolean>
}

export function buildDefaultSubtopicFields(
  bucket: SeedBucket,
  topicSlug: string,
  subtopicSlug: string,
): SubtopicFieldForm {
  const values = SEED_BUCKETS[bucket]
  return {
    mastery: String(getSeedMasteryForSubtopic(bucket, topicSlug, subtopicSlug)),
    stabilityDays: String(values.stabilityDays),
    difficulty: String(values.difficulty),
  }
}

export function clearOverridesOnBucketChange(): SeedFormOverrideState {
  return {
    subtopicFields: {},
    subtopicIncluded: {},
  }
}

export function diffOverrideFromDefaults(
  defaults: SubtopicFieldForm,
  current: SubtopicFieldForm,
): SubtopicSeedOverride | undefined {
  const override: SubtopicSeedOverride = {}

  const defaultMastery = parseSeedMastery(defaults.mastery)
  const mastery = parseSeedMastery(current.mastery)
  if (mastery !== undefined && mastery !== defaultMastery) {
    override.mastery = mastery
  }

  const defaultStabilityDays = parseSeedStabilityDays(defaults.stabilityDays)
  const stabilityDays = parseSeedStabilityDays(current.stabilityDays)
  if (stabilityDays !== undefined && stabilityDays !== defaultStabilityDays) {
    override.stabilityDays = stabilityDays
  }

  const defaultDifficulty = parseSeedDifficulty(defaults.difficulty)
  const difficulty = parseSeedDifficulty(current.difficulty)
  if (difficulty !== undefined && difficulty !== defaultDifficulty) {
    override.difficulty = difficulty
  }

  return Object.keys(override).length > 0 ? override : undefined
}
